import { useTranslation } from "react-i18next";
import { Badge } from "@nexus/ui";
import type { EventJobStatus } from "@/features/events/api/events.api";

/**
 * Maps job status onto the design-system status chips. The dot is decorative —
 * the label always carries the meaning, so status is never colour-alone.
 */
const STATUS_VARIANT: Record<
  EventJobStatus,
  "status-delivered" | "status-error" | "status-sent" | "slate"
> = {
  COMPLETED: "status-delivered",
  FAILED: "status-error",
  PROCESSING: "status-sent",
  PENDING: "slate",
};

const STATUS_LABEL_FALLBACK: Record<EventJobStatus, string> = {
  COMPLETED: "Completed",
  FAILED: "Failed",
  PROCESSING: "Processing",
  PENDING: "Pending",
};

export function useEventStatusLabel(): (status: EventJobStatus) => string {
  const { t } = useTranslation();
  return (status) =>
    t(`admin.events.status.${status}`, STATUS_LABEL_FALLBACK[status]);
}

export function EventStatusBadge({ status }: { status: EventJobStatus }) {
  const statusLabel = useEventStatusLabel();

  return (
    <Badge variant={STATUS_VARIANT[status]} dot>
      {statusLabel(status)}
    </Badge>
  );
}
